<template>
  <div>
    <div class="search-drawer-lands">
      <div class="form__container">
        <i-form class="form" :label-width="80">
          <i-form-item label="敷地権利">
            <i-select v-model="search.right_of_site" size="small" placeholder clearable filterable style="width:160px;">
              <i-option v-for="(item, idx) in master.right_of_site" :value="item.cd" :key="idx">
                {{ item.label }}
              </i-option>
            </i-select>
          </i-form-item>
          <i-form-item label="土地面積">
            <i-input v-model="search.land_area" style="width: 80px;" placeholder clearable filterable size="small" />
            <span class="form__text">㎡以上</span>
          </i-form-item>
          <i-form-item label="建ぺい率">
            <i-input
              v-model="search.land_coverage_ratio"
              style="width: 80px;"
              placeholder
              clearable
              filterable
              size="small"
            />
            <span class="form__text">％以上</span>
          </i-form-item>
          <i-form-item label="容積率">
            <i-input
              v-model="search.land_capacity_ratio"
              style="width: 80px;"
              placeholder
              clearable
              filterable
              size="small"
            />
            <span class="form__text">％以上</span>
          </i-form-item>
        </i-form>
      </div>
    </div>
  </div>
</template>

<script>
import { Input, Form, FormItem, Select, Option } from 'view-design'
export default {
  components: {
    'i-input': Input,
    'i-form': Form,
    'i-form-item': FormItem,
    'i-select': Select,
    'i-option': Option,
  },
  data() {
    return {}
  },
  computed: {
    search: {
      get() {
        return this.$store.getters['SearchProperty/getSearch']
      },
      set(val) {
        this.$store.commit('SearchProperty/setSearch', val)
      },
    },
    master() {
      return this.$store.getters['Master/getMaster']
    },
  },
}
</script>

<style lang="scss" scoped>
.search-drawer-lands {
  .form {
    &__container {
      height: calc(100vh - 280px);
      overflow: scroll;
    }
    &__text {
      display: inline-block;
      margin: 0 8px;
    }
  }
}
</style>
